// extracted by mini-css-extract-plugin
export default {"container":"EditProfileAboutMe_container__C5Syd","textArea":"EditProfileAboutMe_textArea__GCG7T"};